import React, { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

/** PWA install prompt (Choose -> Install -> Use). */
export function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!show || !deferred) return null;
  return (
    <div data-testid="install-prompt" className="fixed inset-x-3 bottom-20 z-50 mx-auto max-w-md animate-fade-up rounded-2xl border border-border bg-card p-4 shadow-2xl md:bottom-4">
      <button data-testid="install-dismiss" onClick={() => setShow(false)}
        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"><X size={16} /></button>
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary text-primary-foreground">
          <DownloadSimple size={22} weight="bold" />
        </div>
        <div className="flex-1">
          <p className="font-display text-sm font-semibold">Install iYeneh Connect</p>
          <p className="text-xs text-muted-foreground">Add to your device for a full-screen app experience.</p>
        </div>
        <button data-testid="install-accept"
          onClick={async () => { deferred.prompt(); await deferred.userChoice; setShow(false); setDeferred(null); }}
          className="rounded-full bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground transition-transform hover:scale-105">
          Install
        </button>
      </div>
    </div>
  );
}
